export enum AppInstallUrls {
  Branch = 'https://wagwalking.app.link/52uv3K5W8jb',
}
